import { useContext } from "react";
import { WidgetContext } from "./WidgetContext";

export function useWidgetContext() {
  const context = useContext(WidgetContext);

  if (!context) {
    throw new Error("useWidgetContext must be used within a WidgetProvider");
  }

  return context;
}
